import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { get } from "lodash";

import { queryClient } from "App";
import { getCampaignStatusesTableColumns } from "routes/campaign_status/components/campaign_statuses_table/CampaignStatusesTableColumnsAndFilters";
import { CAMPAIGN_STATUSES_TABLE_CONSTANTS } from "routes/campaign_status/components/campaign_statuses_table/CampaignStatusesTableV3";
import UserService from "services/User";
import { addResizedColumns } from "hooks/useTableConfig";
import { CAMPAIGN_STATUS_PRESETS_TABLE_CONSTANTS } from "routes/campaign_status_presets/CampaignStatusPresetsTableV3";

export const invalidateCampaignStatusesQuery = async () => {
  await queryClient.invalidateQueries({
    queryKey: [CAMPAIGN_STATUSES_TABLE_CONSTANTS.queryKey],
  });
  // Deleting a status removes it from every preset that offered it.
  await queryClient.invalidateQueries({
    queryKey: [CAMPAIGN_STATUS_PRESETS_TABLE_CONSTANTS.queryKey],
  });
};

export const useCampaignStatusesTable = () => {
  const { data: tableSettings, isSuccess: isTableSettingsFetched } = useQuery({
    queryKey: ["table-settings"],
    queryFn: UserService.getUserSettings,
  });

  const columns = useMemo(() => {
    if (!isTableSettingsFetched) return [];
    const initialColumns = getCampaignStatusesTableColumns();

    const campaignStatusesTableSettings = get(
      tableSettings,
      `user_settings.preferences.tables.${CAMPAIGN_STATUSES_TABLE_CONSTANTS.tableName}`,
      {}
    );

    const withResizedColumns = addResizedColumns({
      columns: initialColumns,
      resizedColumns: campaignStatusesTableSettings?.resized_columns || {},
    });

    return withResizedColumns;
  }, [tableSettings, isTableSettingsFetched]);

  return { columns };
};
